import { axiosClassic } from '../api'

export interface Street {
	id: number
	fullStreetName: string
	shortStreetType: string
	streetName: string
	streetType: string
}

class StreetsService {
	private BASE_URL = '/streets'

	async search(query: string): Promise<Street[]> {
		const response = await axiosClassic.get<Street[]>(
			`${this.BASE_URL}/search`,
			{
				params: { q: query },
			},
		)
		return response.data
	}
}

export const streetsService = new StreetsService()
